import { type ResourceItemDTO, type ResourceHeaderDTO, type UnitDTO } from '@/src/ui';

export const filterSlidesData = (
    grade: string,
    slidesData: ResourceItemDTO[]
): ResourceItemDTO[] => {
    switch (grade) {
        case 'K':
            return slidesData.filter((item) => {
                return item.key && (
                    item.key.includes('Unit6') ||
                    item.key.includes('Unit8')
                );
            });
        case '1':
            return slidesData.filter((item) => {
                return item.key && (
                    item.key.includes('Unit3') ||
                    item.key.includes('Unit5') ||
                    item.key.includes('Unit11')
                );
            });
        case '2':
            return slidesData.filter((item) => item.key && item.key.includes('Unit5'));
        case '3':
            return slidesData.filter((item) => {
                return item.key && (
                    item.key.includes('Unit6') ||
                    item.key.includes('Unit7') ||
                    item.key.includes('Unit8')
                );
            });
        case '4':
            return slidesData.filter((item) => {
                return item.key && (
                    item.key.includes('Unit5') ||
                    item.key.includes('Unit6') ||
                    item.key.includes('Unit7')
                );
            });
        case '5':
            return slidesData.filter((item) => {
                return item.key && (
                    item.key.includes('Unit5') ||
                    item.key.includes('Unit6') ||
                    item.key.includes('Unit8')
                );
            });
        case '6':
            return slidesData.filter((item) => item.key && item.key.includes('Unit10'));
        case '6M':
        // Allow all
        // falls through
        case '7':
        // Allow all
        // falls through
        case '8':
        // Allow all
        // falls through
        default:
            return slidesData;
    }
};

export const filterUnitsData = (grade: string, unitsData: UnitDTO[]): UnitDTO[] => {
    let allowedUnits = [];
    switch (grade) {
        case 'K':
        case '1':
        case '2':
            allowedUnits = ['5', '6'];
            break;
        case '3':
            allowedUnits = ['1', '2', '3', '4', '5', '6', '7'];
            break;
        case '4':
            allowedUnits = ['1', '2', '4', '5', '6', '7'];
            break;
        case '5':
            allowedUnits = ['1', '2','5', '6', '7'];
            break;
        case '6':
        case '6M':
            allowedUnits = ['1', '2'];
            break;
        case '7':
            allowedUnits = ['1', '2', '3', '4', '5'];
            break;
        case '8':
            allowedUnits = ['1', '2', '3', '4'];
            break;
        default:
            return unitsData;
    }

    return unitsData.map((unit) => {
        if (!allowedUnits.includes(`${unit.unitNumber}`)) {
            unit.lessons = unit.lessons.map((lesson) => {
                if (!lesson.subitems) return lesson;

                lesson.subitems = lesson.subitems.filter((subitem) => {
                    return subitem.type && subitem.type !== 'Lesson Video';
                });

                return lesson;
            });
        }
        return unit;
    });
};

export const filterResourcesData = (assessmentsData: ResourceHeaderDTO[]): ResourceHeaderDTO[] => {
    let newResourcesData = [...assessmentsData];
    function removeActivityResources() {
        return newResourcesData.map((item: ResourceHeaderDTO) => {
            if (item.key === 'BTBFBox') {
                const fluencyWorksheets: ResourceItemDTO | undefined = item.items?.find(
                    (subitem: ResourceItemDTO) => subitem.text === 'Fluency Worksheets'
                );
                if (fluencyWorksheets) {
                    fluencyWorksheets.subitems = fluencyWorksheets.subitems?.filter(
                        (subitem: ResourceItemDTO) => !subitem.text.includes('Online Practice')
                    );
                }
            }
            return item;
        });
    }

    newResourcesData = removeActivityResources();

    
    function removeExemplarBox() {
        return newResourcesData.filter((item: ResourceHeaderDTO) => item.key !== 'exemplarsBox');
    }

    newResourcesData = removeExemplarBox();

    return newResourcesData;
};

export const filterAssessmentsData = (
    assessmentsData: ResourceHeaderDTO[]
): ResourceHeaderDTO[] => {
    let newAssessmentData = [...assessmentsData];
    function removeOnlineAssessments() {
        return newAssessmentData.filter(
            (item: ResourceHeaderDTO) => item.key !== 'onlineAssessmentsBox'
        );
    }
    function removeActivitiesByStandard() {
        return newAssessmentData.filter(
            (item: ResourceHeaderDTO) => item.key !== 'activitesByStandardBox'
        );
    }

    newAssessmentData = removeOnlineAssessments();
    newAssessmentData = removeActivitiesByStandard();
    return newAssessmentData;
};
